import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import { InterntPackageTypeApi } from '../../services/api/InternetPackage';
// import {
//     // FetchError,
//     // SetLoginAction,
//     FetchInternetPackage
// } from "./actions"
import { ChargePackageActionTypes } from './types'

// function* handleInternetPackageTypes(action: ReturnType<typeof FetchInternetPackage>) {
//     // @ts-ignore
//     const res = yield call(() => InterntPackageTypeApi(action.payload));
//     if (res) {
//         console.log(res, 'res')
//         // yield put(SetLoginAction(res))
//     } else {
//         console.log('error')

//         // yield put(FetchError())
//     }
// }

// function* watchInternetPackageTypes() {
//     console.log('watch internet package type');

//     yield takeLatest(ChargePackageActionTypes.FETCH_INTERNET_PACKAGE_TYPES, handleInternetPackageTypes)
// }
function* watchWalletChargeTypes() {

}

function* chargePackageSaga() {
    yield all([
        fork(watchWalletChargeTypes),
    ])
}

export default chargePackageSaga